import api from "../../index";

export const GetOrganizerListApi = () => api.post('clientfilelist');
export const CreateChatApi = (data) => api.post('chatcreate', data);
export const GetActiveChatApi = () => api.post('chatroomsbydate');
export const GetArchiveChatApi = () => api.post('archivechatlist');
export const GetMessageListApi = (data) => api.post('chatmessageslist', data);